import * as LABELS_ACTION_TYPE from './labelConstants';
import { Label } from './labelTypes';
import { getNewTransactionId } from '../../client/utils/undoRedo/undoRedoTransactionManager';

export const loadLabels = (labels: Label[] = []) => ({
    type: LABELS_ACTION_TYPE.LABELS_LOAD,
    labels,
});

export const createLabel = (label: Label, transactionId: number = getNewTransactionId()) => ({
    type: LABELS_ACTION_TYPE.LABEL_CREATE,
    label,
    transactionId,
    sync: true,
});

export const recreateLabel = (label: Label, transactionId: number = getNewTransactionId()) => ({
    type: LABELS_ACTION_TYPE.LABEL_RECREATE,
    label,
    transactionId,
    sync: true,
});

export const updateLabel = (labelId: string, changes: Partial<Label>) => ({
    type: LABELS_ACTION_TYPE.LABEL_UPDATE,
    labelId,
    changes,
    transactionId: getNewTransactionId(),
    sync: true,
});

export const deleteLabel = (labelId: string, elementIds: string[] = []) => ({
    type: LABELS_ACTION_TYPE.LABEL_DELETE,
    labelId,
    elementIds,
    transactionId: getNewTransactionId(),
    sync: true,
});

export const selectLabels = (labelId: string, elementId: string) => ({
    type: LABELS_ACTION_TYPE.LABEL_SELECT,
    selectedLabel: { id: labelId, elementId },
});

export const deselectLabels = () => ({
    type: LABELS_ACTION_TYPE.LABEL_SELECT,
    selectedLabelId: null,
});
